import { useState } from 'react';


import './app.css';
import Menu from './components/menu/Menu';
import Navbar from './components/navbar/Navbar';
import About from './pages/about/About';
import Architecture from './pages/architecture/Architecture';
import Contact from './pages/contact/Contact';
import Home from './pages/home/Home';
import WebApp from './pages/webApp/WebApp';
import WebAppSingle from './pages/webAppSingle/WebAppSingle';
import ArchiSingle from './pages/archiSingle/ArchiSingle';
import Blog from './pages/blog/Blog';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { ScrollToTop } from './utils/Helpers';
import ProdDesign from './pages/prodDesign/ProdDesign';



function App() {

  const [menuOpen, setMenuOpen] = useState(true);




  return (
    <div className="app">
      <Router>
        <ScrollToTop>
          <Navbar menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
          <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
          <div className="app__sectionWrapper">
              <Switch>
                <Route exact path="/">
                  <Home />
                </Route>
                <Route exact path="/contact">
                  <Contact />           
              </Route>
              <Route exact path="/webapp">
                  <WebApp />           
              </Route>
              <Route exact path="/webapp/:id">
                  <WebAppSingle />           
              </Route>
              <Route exact path="/architecture">
                  <Architecture />            
              </Route>
              <Route exact path="/architecture/:id">
                  <ArchiSingle />            
              </Route>
              <Route exact path="/proddesign">
                  <ProdDesign />           
              </Route>
              <Route exact path="/about">
                  <About />           
              </Route>
              <Route exact path="/blog">
                  <Blog />           
              </Route>
              </Switch>
          </div>
          </ScrollToTop>
      </Router>
    </div>
  );
}

export default App;
